module.exports = __webpack_public_path__ + "static/img/AMac.ee3f50f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AMac.png
// module id = I7eI
// module chunks = 3